import cx from 'classnames'
import React from 'react'
import { MdChecklistRtl } from 'react-icons/md'
import { useSlate } from 'slate-react'

import { insertCheckboxList, isBlockTypeActive, isCheckboxListFeasible } from '../util'

export function CheckboxListButton ({ label = 'Checkbox list' }) {
  const editor = useSlate()
  const isActive = isBlockTypeActive(editor, 'checkbox-list-item')
  const isFeasible = isCheckboxListFeasible(editor)
  const title = [ label, isActive && '(active)' ].filter(Boolean).join(' ')

  return (
    <button
      type='button'
      className={cx('rounded-sm transition-colors flex flex-row gap-3 w-full disabled:text-[#aaaaaa] disabled:cursor-not-allowed', [
        isActive ? 'text-primary' : 'text-[#9CA3AF]'
      ])}
      onMouseDown={event => {
        event.preventDefault()
        insertCheckboxList(editor)
      }}
      disabled={!isFeasible}
      title={title}
    >
      <MdChecklistRtl size='1.2rem' />
    </button>
  )
}
